// extracted by mini-css-extract-plugin
module.exports = {"modal__close":"UgraphicModal_modal__close__3DC0N"};